import { RefObject, useLayoutEffect, useRef } from 'react';

export const useAlphabetHeight = (onHeightChange: (height: number) => void): RefObject<HTMLDivElement> => {
  const ref = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const element = ref.current;

    if (!element) {
      return undefined;
    }
    const measure = () => onHeightChange(Math.ceil(element.getBoundingClientRect().height));

    measure();
    if (typeof ResizeObserver === 'undefined') {
      return undefined;
    }
    const observer = new ResizeObserver(measure);

    observer.observe(element);

    return () => observer.disconnect();
  }, [onHeightChange]);

  return ref;
};
